module.exports = __webpack_public_path__ + "img/35.0c635969.png";